export const customTheme = {
  colors: {
    background: "#131313",
    main: "#fff",
    secondary: "#131313",
    tableBorder: "#c7c7c7",
  },
};
